<template>
  <router-link :to="to" class="transition-all duration-200"
               @click="clicked">
    <div class="flex pr-6 py-4">
      <slot></slot>
      <div class="ml-auto mr-4">
        <h3>{{ title }}</h3>
        <h6 class="text-muted text-sm mt-2">{{ subtitle }}</h6>
      </div>

      <div class="vertical"></div>
    </div>

  </router-link>
</template>

<script>
export default {
  name: "SettingItem",
  props: ['title', 'subtitle', 'to'],
  methods: {
    clicked() {
      if (this.to === '/logout') {
        this.$store.dispatch('logout')
      }
    }
  }
}
</script>

<style scoped>
a.router-link-active {
  @apply bg-accent/30
}

a.router-link-active div.vertical {
  @apply border-l-4 border-accent rounded-xl
}
</style>